<script lang="ts">
  import { fade, slide } from 'svelte/transition'
  import { createEventDispatcher } from 'svelte'

  export let isOpen = false
  export let title = ''
  export let maxWidth = 'max-w-md'

  const dispatch = createEventDispatcher()

  function close() {
    dispatch('close')
  }
</script>

{#if isOpen}
  <div 
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" 
    transition:fade
    on:click|self={close}
  >
    <div 
      class="bg-gray-900 border border-white/10 rounded-3xl shadow-2xl w-full {maxWidth} p-8 relative overflow-hidden" 
      transition:slide
    >
      <div class="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500"></div>
      
      {#if title}
        <h3 class="text-2xl font-black text-white mb-6">{title}</h3>
      {/if}
      
      <slot />
    </div>
  </div>
{/if}
